import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const propTypes = {
  children: PropTypes.node,
  renderAs: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
}

const TileIcon = ({ children, className, renderAs: Element = 'div', ...attributes }) => {
  const classNames = classnames('tile-icon', className)

  return (
    <Element {...attributes} className={classNames}>
      {children}
    </Element>
  )
}

TileIcon.propTypes = propTypes

export default TileIcon
